import {ConfiguratorPage} from "./pages/ConfiguratorPage";
import './App.css';


function App() {
  return (
    <div className="App">
      <ConfiguratorPage/>
    </div>
  );
}

export default App;
